import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivatePortal from "./pages/private";
import PublicPortal from "./pages/public";
import Home from "./pages/public/Interview/Home";
import "./App.css";
import PrintPayrollView from "./pages/PrintPages/PrintPayrollView";
import PrintEmployee from "./pages/PrintPages/PrintEmployee";
import PrintEmployeeMonthlyAttend from "./pages/PrintPages/PrintEmployeeMonthlyAttend";
import PrintPayslips from "./pages/PrintPages/PrintPayslips";
import PrintDailyReport from "./pages/PrintPages/PrintDailyReport";

function App() {
  return (
    <>
      <Routes>
        <Route
          path="/*"
          element={
            <AuthGuardRedirect redirectTo="/user/profile">
              <PublicPortal />
            </AuthGuardRedirect>
          }
        />
        <Route
          path="user/*"
          element={
            <RequireAuth redirectTo="/">
              <PrivatePortal />
            </RequireAuth>
          }
        />
        <Route
          path="/home"
          element={
            <React.Suspense fallback={<></>}>
              <Home />
            </React.Suspense>
          }
        />
        <Route
          path="/meeting/:token/setup"
          element={<React.Suspense fallback={<></>}></React.Suspense>}
        />
        <Route
          path="/meeting/:token/start"
          element={<React.Suspense fallback={<></>}></React.Suspense>}
        />
        <Route path="/user/payrolls/print" element={<PrintPayrollView />} />
        <Route path="/user/employee/print" element={<PrintEmployee />} />
        <Route path="/user/daily-report/print" element={<PrintDailyReport />} />
        <Route path="/user/payrolls/payslip" element={<PrintPayslips />} />
        <Route
          path="/user/employee-report/print"
          element={<PrintEmployeeMonthlyAttend />}
        />
      </Routes>
      <ToastContainer hideProgressBar />
    </>
  );
}

export default App;

function RequireAuth({ children, redirectTo }) {
  const isAuthenticated = localStorage.getItem("token");
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} />;
  }
  return isAuthenticated ? children : null;
}
function AuthGuardRedirect({ children, redirectTo }) {
  const isAuthenticated = localStorage.getItem("token");
  return isAuthenticated ? <Navigate to={redirectTo} /> : children;
}
